import React, { useState, useEffect } from 'react';
import CheckRegisterSelect from '../CheckRegister/CheckRegisterSelect';
import CheckRegisterCard from '../CheckRegister/CheckRegisterCard';
import {
    Button, Row, Col
} from 'reactstrap';

function CheckRegister(props) {
    const [checkSelectModal, setCheckSelectModal] = useState(false);
    const [selectedCheck, setSelectedCheck] = useState(null);

    useEffect(() => {
        props.updateCheck(selectedCheck);
    }, [selectedCheck]);

    const toggleCheckRegisterSelectModal = () => setCheckSelectModal(!checkSelectModal);

    const selectCheck = (check) => {
        if (check !== null) {
            setSelectedCheck(check);
        }
    };

    const cancelCheck = (checkId) => {
        if (selectedCheck.PK_ID === checkId) {
            setSelectedCheck(null);
        }
    };

    const checkRegisterCardOptions = {
        fields: {
            division: true,
            feeType: true,
            checkFrom: true,
            checkNumber: true,
            amount: true,
            checkDate: true,
            receivedDate: true,
            comments: true
        },
        actions: {
            view: false,
            select: false,
            cancel: true
        }
    };

    const checkRegisterSelectOptions = {
        fields: {
            division: true,
            feeType: true,
            checkFrom: true,
            checkNumber: true,
            amount: true,
            checkDate: true,
            receivedDate: true,
            comments: true
        },
        actions: {
            view: false,
            select: true,
            cancel: false
        }
    };

    return (
        <div>
            <div className="select-btn">
                <Button color="danr-green" className="btn-block" onClick={toggleCheckRegisterSelectModal}><span>Select Check</span></Button>
            </div>
            <Row className="selection">
                <Col>
                {selectedCheck !== null ? <CheckRegisterCard check={selectedCheck} cancel={cancelCheck} options={checkRegisterCardOptions} /> : null}
                </Col>
            </Row>
            <CheckRegisterSelect multiple={false} open={checkSelectModal} toggle={toggleCheckRegisterSelectModal} select={selectCheck} checkRegisterCardOptions={checkRegisterSelectOptions} />
        </div>
    );
}

export default CheckRegister;